<div class="cf-flex-column cf-flex-1">
  <label
    class="ac-form-field-label cf-flex"
    [ngClass]="{ 'ac-form-field-label-disabled': !property.Rules.EnableIf, 'ac-form-field-label-readonly': property.Rules.ReadOnlyIf }"
  >
    <span>{{ propertyType.NameId ? (propertyType.NameId | translate) : property.Key }}</span>
    <span *ngIf="property.Rules.RequiredIf" class="required-sign"> *</span>
    <span
      *ngIf="propertyType | tooltipTextId"
      class="ac-label-tooltip-container"
      [matTooltip]="propertyType | tooltipTextId | translate"
      [matTooltipPosition]="'above'"
      ><mat-icon class="ac-tooltip-icon help" svgIcon="help_outline"></mat-icon></span
  ></label>
  <mat-form-field [attr.data-test]="property.Key" class="cf-flex" appearance="outline" subscriptSizing="dynamic">
    <input
      matInput
      appNumberInput
      [localeCode]="localeCode$ | async"
      [disabled]="propertyForm.disabled"
      [numberFormControl]="propertyForm"
      [numberOfDecimals]="this.property?.MeasurementUnit?.Decimals"
      type="text"
      inputmode="numeric"
      [placeholder]="placeholder"
      (focus)="focused = true"
      (blur)="focused = false"
    />

    <span matTextSuffix *ngIf="measurementUnit$ | async as unit">{{ unit.TextId | translate }}</span>
  </mat-form-field>
  <div class="ac-form-field-message-error">
    <mat-error *ngIf="propertyForm.errors && propertyForm.errors['numericValue']" translate>
      UI.Common.Validation.ValueNotNumeric
    </mat-error>
    <mat-error
      *ngIf="propertyForm.errors && propertyForm.errors['min']"
      translate
      [translateParams]="{ minValue: getMinValue(propertyForm) }"
    >
      UI.Common.Validation.ValueTooLow
    </mat-error>
    <mat-error
      *ngIf="propertyForm.errors && propertyForm.errors['max']"
      translate
      [translateParams]="{ maxValue: getMaxValue(propertyForm) }"
    >
      UI.Common.Validation.ValueTooHigh
    </mat-error>
    <mat-error *ngIf="propertyForm.errors && propertyForm.errors['required']" translate> UI.Common.Validation.ValueRequired </mat-error>
    <mat-error
      *ngIf="propertyForm.errors && propertyForm.errors['tooManyDecimals']"
      translate
      [translateParams]="{ maxDecimals: property.MeasurementUnit?.Decimals }"
    >
      UI.Common.Validation.ValueTooPrecise
    </mat-error>
  </div>
  <div *ngFor="let message of messages">
    <div
      [ngClass]="{
        'ac-form-field-message-error': message.Properties['Level']?.Value === 0,
        'ac-form-field-message-warning': message.Properties['Level']?.Value === 1,
        'ac-form-field-message-info': message.Properties['Level']?.Value === 2
      }"
    >
      {{ message.Properties['Text']?.Value || (message.Properties['TextId']?.Value | translate) }}
    </div>
  </div>
</div>
